import ContentHeader from './container'

export default ContentHeader



// WEBPACK FOOTER //
// ./src/legacy/containers/ContentHeader/index.js